"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantContent = void 0;
/**
 * Constant content definitions for sensenet
 */
class ConstantContent {
}
exports.ConstantContent = ConstantContent;
/**
 * Defines a visitor user content
 */
ConstantContent.VISITOR_USER = {
    Id: 6,
    DisplayName: 'Visitor',
    Domain: 'BuiltIn',
    Name: 'Visitor',
    Path: '/Root/IMS/BuiltIn/Portal/Visitor',
    LoginName: 'Visitor',
    Type: 'User',
};
/**
 * Defines a portal root content
 */
ConstantContent.PORTAL_ROOT = {
    Id: 2,
    Path: '/Root',
    Name: 'Root',
    DisplayName: 'Root',
    Type: 'PortalRoot',
};
ConstantContent.EMPTY_CONTENT = {
    Id: 0,
    Path: '',
    Name: '',
    DisplayName: '',
    Type: '',
};
//# sourceMappingURL=ConstantContent.js.map